<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 39 39"
        version="1.1"
        :class="customClasses"
    >
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group">
                <g id="images" fill="#4E869E" fill-rule="nonzero">
                    <path d="M19.449,38.897 C8.725,38.897 0,30.172 0,19.45 C0,8.725 8.725,0 19.449,0 C30.172,0 38.897,8.725 38.897,19.449 C38.897,30.172 30.172,38.897 19.449,38.897 L19.449,38.897 Z" id="Path"></path>
                </g>
                <g id="Group-7" transform="translate(7.000000, 8.000000)" fill="#FFFFFF">
                    <path d="M17.5833055,0 L0,6.3862996 L5.05628037,19.9782783 L5.26642772,19.9019691 L5.26642772,20 L24,20 L24,5.51894351 L19.6364158,5.51894351 L17.5833055,0 Z M16.4822939,2.33253058 L17.6676065,5.51894351 L7.70918359,5.51894351 L16.4822939,2.33253058 Z M2.36775787,7.45890982 L5.26642772,6.40613244 L5.26642772,15.2509484 L2.36775787,7.45890982 Z M7.11429709,17.2982638 L7.11429709,7.33279816 L18.3423975,7.33279816 L20.311143,7.33279816 L22.1521306,7.33279816 L22.1521306,12.2816263 L22.1521306,13.7690261 L22.1521306,18.1860824 L9.99072879,18.1860824 L7.11429709,18.1860824 L7.11429709,17.2982638 Z" id="Fill-1"></path>
                    <g id="Group-6" transform="translate(9.000000, 9.000000)">
                        <path d="M2.85000638,1.45033548 C2.85000638,2.23420645 2.22128298,2.86969032 1.44575106,2.86969032 C0.670219149,2.86969032 0.0414957447,2.23420645 0.0414957447,1.45033548 C0.0414957447,0.666464516 0.670219149,0.0309806452 1.44575106,0.0309806452 C2.22128298,0.0309806452 2.85000638,0.666464516 2.85000638,1.45033548" id="Fill-2"></path>
                        <polygon id="Fill-4" points="0.232985106 7.96646452 11.977666 7.96646452 10.1904319 2.09549677 9.23298511 2.67614194 8.21170851 0.805174194 4.31809149 6.09549677 2.85000638 4.67614194"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            },
            hexColor: {
                type: String,
                required: false,
                default: '#000000'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
                'icon--large': props.size === 'large'
            })

            return {
                customClasses
            }
        }
    })
</script>
